import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isCondoScopedPath } from './routes';
import { getCurrentCondoTab } from './condoNavItems';

/* Resolves which condo the fixed mobile bottom tab bar should point at.
   On a condo page that's the slug in the URL; elsewhere (account/admin/
   approvals/etc.) it falls back to the user's first condo so the bar
   stays present, with no tab highlighted since we're not inside a condo
   section. Returns slug: null when there's no condo to link to (signed
   out, pending approval, or an admin-only user with no condos). */
export function useBottomNavTarget() {
  const location = useLocation();
  const { user, isAuthenticated, isActive } = useAuth();

  if (!isAuthenticated || !isActive) {
    return { slug: null, currentTab: null };
  }

  const onCondoPage = isCondoScopedPath(location.pathname);
  const pathSlug = onCondoPage ? location.pathname.split('/').filter(Boolean)[0] : null;

  const homeCondo = user?.condos?.[0];
  const homeSlug = homeCondo?.slug || (typeof homeCondo === 'string' ? homeCondo : undefined);

  return {
    slug: pathSlug || homeSlug || null,
    currentTab: pathSlug ? getCurrentCondoTab(location.pathname) : null,
  };
}
